

    /**
     * "Convert" value into a 32-bit unsigned integer.
     * IMPORTANT: Value will wrap at 2^32.
     */
    function toUInt(val){
        // we do not use lang/toNumber because of perf and also because it
        // doesn't break the functionality
        return val >>> 0;
    }

    module.exports = toUInt;





//////////////////
// WEBPACK FOOTER
// ./~/mout/number/toUInt.js
// module id = 1631
// module chunks = 0 1 2